var _g, _ellipse, _feBlend, _feBlend2, _mask, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1122 1122",
    style: {
      "enableBackground": "new 0 0 1122 1122"
    },
    xmlSpace: "preserve"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bg"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Object"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046336391225930403640000006971421284136533672_",
    gradientUnits: "userSpaceOnUse",
    x1: 468.9427,
    y1: 561.4942,
    x2: 866.8499,
    y2: 561.4942,
    gradientTransform: "matrix(1.1796 -8.981986e-04 7.614322e-04 1 -21.4469 0.1057)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      "stopColor": "#D7B676"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0189,
    style: {
      "stopColor": "#CFAF72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2083,
    style: {
      "stopColor": "#826F4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3646,
    style: {
      "stopColor": "#494131"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4801,
    style: {
      "stopColor": "#26241F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5421,
    style: {
      "stopColor": "#191919"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    style: {
      "stopColor": "#25231F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6952,
    style: {
      "stopColor": "#443D2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8261,
    style: {
      "stopColor": "#776748"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9828,
    style: {
      "stopColor": "#BDA06A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#C5A76E"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      "fill": "none",
      "stroke": "url(#SVGID_00000046336391225930403640000006971421284136533672_)",
      "strokeWidth": 3,
      "strokeMiterlimit": 10
    },
    x1: 532.15,
    y1: 561,
    x2: 1001.53,
    y2: 561
  }), /*#__PURE__*/React.createElement("g", null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -164.3223 725.2903)",
    className: "st333",
    cx: 793.34,
    cy: 561,
    rx: 31.5,
    ry: 31.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083074756398908401400000014524186260707487150_",
    gradientUnits: "userSpaceOnUse",
    x1: -197.8765,
    y1: -1862.3707,
    x2: -197.8765,
    y2: -1796.3756,
    gradientTransform: "matrix(0.7187 0.6953 -0.6953 0.7187 -336.3991 2013.3937)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      "stopColor": "#AB8D60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0682,
    style: {
      "stopColor": "#B29466"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5057,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#AB8D60"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      "fill": "url(#SVGID_00000083074756398908401400000014524186260707487150_)"
    },
    d: "M770.4,584.72 c-6.33-6.13-9.9-14.36-10.05-23.17c-0.15-8.81,3.15-17.15,9.28-23.49c6.13-6.33,14.36-9.9,23.17-10.05l0,0l0,0 c8.81-0.15,17.15,3.15,23.49,9.28c6.34,6.13,9.9,14.36,10.05,23.17c0.15,8.81-3.15,17.15-9.28,23.49 c-6.13,6.34-14.36,9.9-23.17,10.05S776.73,590.84,770.4,584.72z M814.2,539.44c-5.76-5.57-13.34-8.57-21.35-8.43l0,0 c-8.01,0.13-15.49,3.38-21.06,9.14s-8.57,13.34-8.43,21.35c0.13,8.01,3.38,15.49,9.14,21.06c5.76,5.57,13.34,8.57,21.35,8.43 c8.01-0.13,15.49-3.38,21.06-9.14s8.57-13.34,8.43-21.35C823.2,552.49,819.96,545.01,814.2,539.44z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116936116476116297140000013617317121915071384_",
    gradientUnits: "userSpaceOnUse",
    x1: -1328.2869,
    y1: 3629.9968,
    x2: -1301.7253,
    y2: 3603.4353,
    gradientTransform: "matrix(-0.6953 0.7187 -0.7187 -0.6953 2478.4341 4020.8176)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      "stopColor": "#AB8D60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0682,
    style: {
      "stopColor": "#B29466"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5057,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#AB8D60"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      "fill": "url(#SVGID_00000116936116476116297140000013617317121915071384_)"
    },
    cx: 793.34,
    cy: 561,
    r: 18.78
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041267811332404003330000007033015013102872718_",
    gradientUnits: "userSpaceOnUse",
    x1: 88.1816,
    y1: 542.7453,
    x2: 114.8096,
    y2: 542.7453,
    gradientTransform: "matrix(-1 0 0 1 1138.6533 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      "stopColor": "#AB8D60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0682,
    style: {
      "stopColor": "#B29466"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5057,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#AB8D60"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      "fill": "url(#SVGID_00000041267811332404003330000007033015013102872718_)"
    },
    d: "M1025.46,554.95l-1.62-1.79l17.87-16.16 l1.62,1.79L1025.46,554.95z M1046.9,535.56l-1.62-1.79l3.57-3.23l1.62,1.79L1046.9,535.56z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080900352546705178120000001645797662977338539_",
    gradientUnits: "userSpaceOnUse",
    x1: 987.1866,
    y1: 542.7453,
    x2: 1013.8146,
    y2: 542.7453
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      "stopColor": "#AB8D60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0682,
    style: {
      "stopColor": "#B29466"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5057,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#AB8D60"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      "fill": "url(#SVGID_00000080900352546705178120000001645797662977338539_)"
    },
    d: "M1012.2,554.95l-17.87-16.16l1.62-1.79 l17.87,16.16L1012.2,554.95z M990.76,535.56l-3.57-3.23l1.62-1.79l3.57,3.23L990.76,535.56z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 994.96,
    y: 537.14,
    width: 47.72,
    height: 47.72
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 994.96,
    y: 537.14,
    width: 47.72,
    height: 47.72,
    id: "SVGID_00000021840972298146169350000009652154722539241917_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000077283575792450262670000007315703836168207248_",
    filterUnits: "userSpaceOnUse",
    x: 994.96,
    y: 537.14,
    width: 47.72,
    height: 47.72
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      "floodColor": "white",
      "floodOpacity": 1
    },
    result: "back"
  }), _feBlend2 || (_feBlend2 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 994.96,
    y: 537.14,
    width: 47.72,
    height: 47.72,
    id: "SVGID_00000021840972298146169350000009652154722539241917_"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057867178616817500000000002683650871900127110_",
    gradientUnits: "userSpaceOnUse",
    x1: -1580.0967,
    y1: 1280.7153,
    x2: -1532.3644,
    y2: 1280.7153,
    gradientTransform: "matrix(0.7103 0.7039 -0.7039 0.7103 3025.7153 746.7397)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      "stopColor": "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5421,
    style: {
      "stopColor": "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#F1F1F1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      "mask": "url(#SVGID_00000021840972298146169350000009652154722539241917_)",
      "fill": "url(#SVGID_00000057867178616817500000000002683650871900127110_)"
    },
    d: " M1018.83,584.86c-6.08,0-12.15-2.3-16.8-6.9c-4.53-4.49-7.04-10.47-7.07-16.84c-0.03-6.37,2.43-12.38,6.91-16.91 c4.49-4.53,10.47-7.04,16.84-7.07c0.04,0,0.07,0,0.11,0c6.33,0,12.29,2.45,16.8,6.91c9.35,9.26,9.42,24.4,0.15,33.75 C1031.12,582.5,1024.98,584.86,1018.83,584.86z M1018.83,539.54c-0.03,0-0.07,0-0.1,0c-5.73,0.03-11.11,2.28-15.14,6.35 c-8.33,8.4-8.27,22.02,0.14,30.34c8.41,8.33,22.02,8.27,30.34-0.14c8.33-8.4,8.27-22.02-0.14-30.34 C1029.89,541.75,1024.53,539.54,1018.83,539.54z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060742410484698394530000012670634244456002218_",
    gradientUnits: "userSpaceOnUse",
    x1: -1580.0967,
    y1: 1280.7153,
    x2: -1532.3644,
    y2: 1280.7153,
    gradientTransform: "matrix(0.7103 0.7039 -0.7039 0.7103 3025.7153 746.7397)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      "stopColor": "#D7B676"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5421,
    style: {
      "stopColor": "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#C5A76E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      "fill": "url(#SVGID_00000060742410484698394530000012670634244456002218_)"
    },
    d: "M1018.83,584.86 c-6.08,0-12.15-2.3-16.8-6.9c-4.53-4.49-7.04-10.47-7.07-16.84c-0.03-6.37,2.43-12.38,6.91-16.91 c4.49-4.53,10.47-7.04,16.84-7.07c0.04,0,0.07,0,0.11,0c6.33,0,12.29,2.45,16.8,6.91c9.35,9.26,9.42,24.4,0.15,33.75 C1031.12,582.5,1024.98,584.86,1018.83,584.86z M1018.83,539.54c-0.03,0-0.07,0-0.1,0c-5.73,0.03-11.11,2.28-15.14,6.35 c-8.33,8.4-8.27,22.02,0.14,30.34c8.41,8.33,22.02,8.27,30.34-0.14c8.33-8.4,8.27-22.02-0.14-30.34 C1029.89,541.75,1024.53,539.54,1018.83,539.54z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088105798208394497270000012670592673871641518_",
    gradientUnits: "userSpaceOnUse",
    x1: 88.1816,
    y1: 4462.5972,
    x2: 114.8096,
    y2: 4462.5972,
    gradientTransform: "matrix(-1 0 0 -1 1138.6533 5041.853)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      "stopColor": "#AB8D60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0682,
    style: {
      "stopColor": "#B29466"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5057,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#AB8D60"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      "fill": "url(#SVGID_00000088105798208394497270000012670592673871641518_)"
    },
    d: "M1048.86,591.46l-3.57-3.23l1.62-1.79 l3.57,3.23L1048.86,591.46z M1041.71,585l-17.87-16.16l1.62-1.79l17.87,16.16L1041.71,585z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067214531404821220880000013700002271018730922_",
    gradientUnits: "userSpaceOnUse",
    x1: 987.1866,
    y1: 4462.5972,
    x2: 1013.8146,
    y2: 4462.5972,
    gradientTransform: "matrix(1 0 0 -1 0 5041.853)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      "stopColor": "#AB8D60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0682,
    style: {
      "stopColor": "#B29466"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5057,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#AB8D60"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      "fill": "url(#SVGID_00000067214531404821220880000013700002271018730922_)"
    },
    d: "M988.8,591.46l-1.62-1.79l3.57-3.23 l1.62,1.79L988.8,591.46z M995.95,585l-1.62-1.79l17.87-16.16l1.62,1.79L995.95,585z"
  })), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st333",
    d: "M1027.99,566.04L1052,561l-24.01-5.04l7.75-11.88l-11.88,7.75l-5.04-24.01l-5.04,24.01l-11.88-7.75 c0,0,3.98,6.09,7.75,11.88L985.65,561c0,0,14.41,3.03,24.01,5.04l-7.75,11.88c0,0,6.09-3.98,11.88-7.75l5.04,24.01 c0,0,3.03-14.41,5.04-24.01l11.88,7.75L1027.99,566.04z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091701413105089122820000010441563896377819539_",
    gradientUnits: "userSpaceOnUse",
    x1: 979.7925,
    y1: 561,
    x2: 1057.8651,
    y2: 561
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      "stopColor": "#AB8D60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0682,
    style: {
      "stopColor": "#B29466"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5057,
    style: {
      "stopColor": "#DBC087"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#AB8D60"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      "fill": "url(#SVGID_00000091701413105089122820000010441563896377819539_)"
    },
    d: "M1018.83,600.04l-5.86-27.9l-15.2,9.92 l9.93-15.2l-27.9-5.86l27.9-5.86l-9.93-15.21l15.21,9.93l5.86-27.9l5.86,27.9l15.2-9.93l-9.93,15.2l27.9,5.86l-27.9,5.86 l9.93,15.2l-15.2-9.92L1018.83,600.04z M1014.6,568.19l4.23,20.12l4.22-20.12l8.55,5.58l-5.58-8.55l20.12-4.23l-20.12-4.23 l5.58-8.55l-8.55,5.58l-4.22-20.12l-4.23,20.12l-8.55-5.58l5.58,8.55L991.51,561l20.12,4.23l-5.58,8.55L1014.6,568.19z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013898577354347821660000001541222981393872045_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.7179,
    y1: 554.6698,
    x2: 544.9612,
    y2: 563.043,
    gradientTransform: "matrix(0.9951 -0.0129 0.0128 0.9999 -17.3125 6.174)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      "stopColor": "#D7B676"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0189,
    style: {
      "stopColor": "#CFAF72"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2083,
    style: {
      "stopColor": "#826F4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3646,
    style: {
      "stopColor": "#494131"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4801,
    style: {
      "stopColor": "#26241F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5421,
    style: {
      "stopColor": "#191919"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5968,
    style: {
      "stopColor": "#25231F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6952,
    style: {
      "stopColor": "#443D2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8261,
    style: {
      "stopColor": "#776748"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9828,
    style: {
      "stopColor": "#BDA06A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      "stopColor": "#C5A76E"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      "fill": "none",
      "stroke": "transparent",
      "strokeWidth": 3,
      "strokeMiterlimit": 10
    },
    x1: 532.15,
    y1: 561,
    x2: 64.13,
    y2: 561
  })));
};

export default __webpack_public_path__ + "static/media/arrow.b2912a19.svg";
export { SvgComponent as ReactComponent };